// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2Kbd_","cell":"ColumnAccessor_cell__3Yy9M","firstCellAccent":"ColumnAccessor_firstCellAccent__3vbmt"};